module.exports = require("@material-ui/icons/Email");